<template>
  <div>
    <div class="detail" v-if="detail.activityName" :style="detail.activityType == 'OFFLINE' ? { paddingBottom: '64px'} : {}">
      <div class="title" v-if="vcardData">
        <div class="vcard" v-if="vcardData">
          <Vcard :posterData="vcardData" :posterImg="vcardUrl" @showMark="(e)=>callingcardShow=e"></Vcard>
        </div>
      </div>
      <!-- 主体 -->
      <div class="content" v-if="detail.activityType === 'ONLINE'">
        <img class="banner" mode="widthFix" :src="detail.bannerUrl" />
        <div class="content-title van-multi-ellipsis--l2">
          {{ detail.activityName }}
        </div>
        <div class="times flex-center">
          <div class="flex-center">
            <div>浏览 {{ detail.visit }}次</div>
            <div style="margin-left: 20px;">转发 {{ detail.forward }}次</div>
          </div>
          <div class="flex-center" style="color: #1F7DDE;" @click="tapCheck">
            <img
              style="width:12px; height: 12px;margin-right: 5px;"
              src="../assets/good.svg"
              v-if="!isStar"
            />
            <img
              style="width:12px; height: 12px;margin-right: 5px;"
              src="../assets/good2.svg"
              v-else
            />
            {{ detail.star }}人点赞
          </div>
        </div>
      </div>
      <!-- 信息 -->
      <div class="msg" v-if="detail.activityType === 'ONLINE'">
        <van-cell-group>
          <van-cell>
            <template slot="title">
              <div class="cell-title">
                <van-icon name="clock-o" />
                <div style="margin-left: 12px;">
                  {{ moment(detail.startTime).format('YYYY-MM-DD HH:mm') }} 至
                  {{ moment(detail.enterLimitTime).format('YYYY-MM-DD HH:mm') }}
                </div>
              </div>
            </template>
          </van-cell>
          <van-cell>
            <template slot="title">
              <div class="cell-title">
                <van-icon name="user-o" />
                <div style="margin-left: 12px;">
                  已有
                  <span style="color: #FE5051; margin:0 5px;">{{
                    detail.enter
                  }}</span>
                  人报名参加
                </div>
              </div>
            </template>
          </van-cell>
          <van-cell>
            <template slot="title">
              <van-tag color="#FBEFEE" size="large"
                ><img
                  src="../assets/cert.svg"
                  style="margin-right: 10px;width: 16px; height: 16px;"
                /><span style="color: #F5222D;"
                  >爆款抢购凭证：￥{{ detail.entryFee }}</span
                ></van-tag
              >
            </template>
          </van-cell>
        </van-cell-group>
      </div>
      <!-- 参与门店 -->
      <div @click="tapCheck" v-if="detail.activityType === 'ONLINE'">
        <JoinStore :activityId="id"></JoinStore>
      </div>
      <!-- 秒杀 -->
      <div class="flash-sales" v-if="detail.activityType === 'ONLINE' && settingMap['SECKILL'] === 'Y'">
        <salesCard
          :activityId="id"
          :num="detail.uv"
          :shareId="shareId"
        ></salesCard>
      </div>
      <!-- 领券 -->
      <div class="coupon" @click="tapCheck" v-if="detail.activityType === 'ONLINE' && detail.activityType === 'ONLINE'">
        <DetailCoupon :activityId="id" :shareId="shareId"></DetailCoupon>
      </div>
      <!-- 卡包 -->
      <div class="card-bag" v-if="detail.activityType === 'ONLINE' && settingMap['CARD_BAG'] === 'Y'">
        <cardBag :activityId="id" :num="detail.uv" :shareId="shareId"></cardBag>
      </div>
      <!-- 活动详情 -->
      <div class="desc" v-if="detail.activityType === 'ONLINE'">
        <div style="width: 132px; margin: auto; border-color: #C8C9CC;">
          <van-divider contentPosition="center"
            ><span style="font-size: 13px; font-weight: bold; color: #000;"
              >活动详情</span
            ></van-divider
          >
        </div>
        <div class="tip">
          点击下方“立即报名”即可参加活动，获得抢购资格。
        </div>
        <div
          style="font-size: 14px; line-height: 22px; padding: 20px 16px 16px 16px;"
        >
          {{ detail.description }}
        </div>
      </div>
      <!-- KV -->
      <div class="imgs" v-if="imgs && imgs.length">
        <div style="font-size: 0;" v-for="(item, index) in imgs" :key="item">
          <block v-if="detail.activityType === 'SPECIAL'">
            <img style="width: 100%;" mode="widthFix" :src="item.path" v-if="item.type === 'image'" />
            <video 
              class="video" 
              :style="{ height: item.height ? item.height + 'px' : '50vh', width: '100%' }"
              :muted="true"
              :autoplay="false"
              :src="item.path" 
              :controls="true" 
              :http-cache="true"
							:show-fullscreen-btn="false"
							:show-loading="false"
							:show-center-play-btn="true"
							:enable-progress-gesture="false"
              :show-mute-btn="true"
							object-fit="cover"
							:loop="false"
              @loadedmetadata="onVideoLoadedMetadata($event, index)"
              v-else-if="item.type === 'video'"
            ></video>
          </block>
          <img style="width: 100%;" mode="widthFix" :src="item" v-else/>
        </div>
      </div>
      <!-- 主办方 -->
      <div class="sponsor" v-if="detail.activityType === 'ONLINE'">
        <!-- <Vcard :posterData="vcardData" disabled></Vcard> -->
        <div class="sponsor-bg">
          <div class="flex-center sponsor-msg" style="margin-bottom: 8px;">
            <img
              src="https://img.esenyun.com/images/20200814/316c23ea6b0a4b9b80366acbc3f45f7e.png"
              style="margin-right:8px;"
            />
            活动主办方：{{ detail.sponsor || 'A.O.史密斯' }}
          </div>
          <div class="flex-center sponsor-msg" @click="makePhone()">
            <img
              src="https://img.esenyun.com/images/20200814/fd75056383ef46778350bc646d3376ea.png"
              style="margin-right:8px;"
            />
            <span style="border-bottom: 1px solid #7D7E80;">
              {{ detail.serviceTel }}
            </span>
          </div>
        </div>
      </div>
      <!-- 电子单页 -->
      <div>
        <contentCard :activityId="id" :shareId="shareId" :vcardData="vcardData"/>
      </div>
      <!-- 同城活动详情 -->
      <div class="float-btn" style="bottom: 64px" v-if="!showDetail && detail.activityType === 'OFFLINE'">
        <img class="arrow-up" style="width:38px; height:38px;" src="../assets/up_btn.svg" @click="showDetail = true"/>
      </div>
      <van-popup 
        v-model="showDetail" 
        position="bottom" 
        :overlay="false"
        :z-index="90"
        style="bottom: 63px; margin-bottom:-1px; background: transparent; padding-top: 46px;border-radius: 10px 10px 0 0"
        :close-on-click-overlay="false"
        :lock-scroll="false"
        v-if="detail.activityType === 'OFFLINE'">
        <div class="float-btn" style="top: 0px; position: absolute">
          <img class="arrow-down" style="width:38px; height:38px;" src="../assets/down_btn.svg" @click="showDetail = false"/>
        </div>
        <div style="background: white;border-radius: 10px 10px 0 0">
          <div class="content" style="border-radius: 10px 10px 0 0;position: relative;">
            <div class="content-title van-multi-ellipsis--l2" style="margin-top:7px">
              <span>{{ detail.activityName }}</span>
            </div>
            <div class="content-desc" v-if="detail.activityDesc">
              <span>{{ detail.activityDesc }}</span>
            </div>
          </div>
          <van-cell-group :border="false">
            <van-cell>
              <template slot="title">
                <div class="cell-title">
                  <img style="width:20px; height:20px" src="../assets/calendar.svg" />
                  <div style="margin-left: 12px;">
                    {{ moment(detail.startTime).format('YYYY-MM-DD HH:mm') }} 至
                    {{ moment(detail.endTime).format('YYYY-MM-DD HH:mm') }}
                  </div>
                </div>
              </template>
            </van-cell>
            <van-cell>
              <template slot="title">
                <div class="cell-title">
                  <img style="width:20px; height:20px" src="../assets/location.svg" />
                  <div class="van-multi-ellipsis--l2" style="margin-left: 12px;flex:1">
                    {{ activityAddressText }}
                  </div>
                  <img style="width:34px; height:34px" src="../assets/map.svg" @click="openLocation"/>
                </div>
              </template>
            </van-cell>
            <van-cell>
              <template slot="title">
                <div class="cell-title">
                  <img style="width:20px; height:20px" src="../assets/percent_bar.svg" />
                  <div style="margin-left: 12px;">
                    报名进度
                  </div>
                  <progress-bar 
                    :percentage="enterPercentage" 
                    stroke-width="12"
                    color="#2B4774 url('https://aosnext-test-img.hotwater.com.cn/images/20240529/0edf6369c60345e99d3f0028f088a027.png') repeat-x"
                    track-color="#B8CBE9CF"
                    :show-privot="false"
                    privot-pos="right" 
                    :privot-text="`${enterPercentage}%`"
                    text-color="#325082" 
                    style="margin-left: 8px; flex:1;"/>
                  <div style="color: #325082;font-weight: 700;font-size: 16px;margin-left: 8px;white-space:nowrap">
                    {{ detail.enter }}<span style="font-weight: 400;">/{{ detail.limitNum || (detail.offline && detail.offline.limitNum) || 9999 }}</span>
                  </div>
                </div>
              </template>
            </van-cell>
          </van-cell-group>
        </div>
      </van-popup>
      <!-- footer -->
      <div class="footer flex-center" v-if="!callingcardShow" >
        <LinkWeappBtn
          :url="`/pages/detail.html?id=${detail.activityId}&shareId=${shareId}`"
        >
          <script type="text/wxtag-template">
              <style>
                .apply-btn {
                  width: 343px;
                  background: linear-gradient(270deg, #306FE2 24.05%, #1F7DDE 73.62%);
                  color: #fff;
                  font-size: 16px;
                  height: 44px;
                  display: flex;
                  align-items: center;
                  justify-content: center;
                  border-radius: 40px;
                  border: none;
                }
              </style>
              <button class="apply-btn"> 参加活动
            </button>
          </script>
        </LinkWeappBtn>
        <div style="height: 20px;"></div>
      </div>
    </div>
    <van-popup v-model="qrModel" closeable :style="{ width: '100%' }">
      <div class="qr_code">
        <img :src="url" alt="" />
        <div>微信中长按识别小程序码</div>
        <div>参加活动</div>
      </div>
    </van-popup>
    <map-location ref="mapLocationViewer"/>
  </div>
</template>

<script>
import moment from 'moment'
import { Toast } from 'vant'
import { mapState } from 'vuex'
import Vcard from '../components/Vcard'
import JoinStore from '../components/JoinStore'
import salesCard from '../components/sales/salesCard'
import cardBag from '../components/card-bag/card'
import DetailCoupon from '../components/DetailCoupon'
import contentCard from '../components/contentCard'
import LinkWeappBtn from '../components/LinkWeappBtn'
import md5 from '../components/md5'
import ProgressBar from '../components/ProgressBar.vue'
import MapLocation from '../components/MapLocation.vue'
export default {
  components: {
    JoinStore,
    salesCard,
    cardBag,
    LinkWeappBtn,
    Vcard,
    DetailCoupon,
    contentCard,
    ProgressBar,
    MapLocation,
  },

  data() {
    return {
      moment: moment,
      showToop: false,
      adList: [],
      imgs: [],
      isEnter: false,
      isStar: false, // 是否点赞
      isFollow: false, // 是否收藏
      notice: '',
      noticeList: [],
      settingMap: {},
      detail: {},
      maskShow: false, // 收藏弹窗
      tabShow: false,
      beforeUrl: '',
      marquee: null,
      isSharepop: false, // 去分享弹框
      codes: '', // 加密的活动id，分享id和活动二维码的code
      id: '', // 当前活动id
      shareId: '', // 分享id
      vcardUrl: '',
      vcardData: {
        name: '',
      },
      url: '', // 当前活动二维码
      qrModel: false, // 活动二维码弹框
      callingcardShow:false,

      showDetail: true,
    }
  },
  computed: {
    ...mapState(['isLogin']),
    activityAddressText() {
      if (this.detail.address) {
        var segs = this.detail.address.split(',', 4)
        if (segs.length == 4) {
          return segs[2] || segs[3]
        } else {
          return this.detail.address
        }
      }
      return ''
    },
    enterPercentage() {
      if (this.detail) {
        return Math.min(100, Math.round(this.detail.enter * 100.0 / (this.detail.limitNum || (this.detail.offline && this.detail.limitNum) || 9999)))
      }
      return 0
    }
  },
  mounted() {
    if (!this.$root.$data.store.state.isInitWx) {
      this.$root.$data.store.initwx(true, this.$route.query.code)
    }
    this.init()

    window.addEventListener("scroll", this.onScrollContent)
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.onScrollContent)
  },
  methods: {
    onScrollContent() {
      if (document.documentElement.scrollTop != 0) {
        this.showDetail = false
      } else {
        this.showDetail = true
      }
    },
    getVcard() {
      this.$http
        .get(
          `aocampaign/openapi/activity/card/${this.id}?shareId=${this.shareId || ''}`
        )
        .then((res) => {
          if (res.data) {
            this.vcardData = res.data
            console.log(22, this.vcardData)
          } else {
            this.vcardData = {}
          }
        })
    },
    // 展示快捷导航
    showNav() {
      this.tabShow = !this.tabShow
    },
    link(path) {
      console.log(path)
    },
    // 操作之前验证是否登陆
    enter(item) {
      item.tranType = 'fade'
    },
    async init() {
      Toast.loading({
        duration: 0,
        message: '刷新加载中...',
        forbidClick: true,
      })
      if (this.$route.query.codes) {
        this.codes = decodeURIComponent(this.$route.query.codes) // 分享链接时存储的code
        await this.getCodeParams()
      } else {
        this.id = this.$route.query.id || this.$route.query.activityId
        this.shareId = this.$route.query.shareId
        this.vcardUrl = this.$route.query.vcardUrl
          ? this.$route.query.vcardUrl
          : ''
      }
      await this.getData()
      this.getVcard()
      this.readyShare()
      this.getWxcode()
    },
    async getWxcode() {
      this.url = await this.$share.getPosterNew({
        id: this.id,
        shareId: this.shareId,
      })
    },
    // 获取存储参数的code
    getCodeParams() {
      return new Promise((s) => {
        this.$http
          .get(
            'aocampaign/openapi/common/parms/restore?key=' +
              encodeURIComponent(this.codes)
          )
          .then((res) => {
            console.log('%c 解密', 'color:orange', res)
            const ids = res.data.split(';&;')
            this.id = ids[0]
            ;(this.shareId = ids[1] ? ids[1] : null),
              (this.url = ids[2] ? ids[2] : null)
            console.log(
              '%c ids',
              'color:orange',
              this.id,
              this.shareId,
              this.url
            )
            s()
          })
      })
    },
    readyShare() {
      window.wx.ready(async () => {
        console.log(112)
        // alert('成功')
        // const shareUrl = encodeURIComponent(`https://dev-wxcp.nextxx.cn/campaign/#/?id=${this.id}`)
        const shareUrl = `${location.origin}${location.pathname}#/activityDetail?activityId=${this.id}&shareId=${this.shareId}&vcardUrl=${this.vcardUrl}`
        //需在用户可能点击分享按钮前就先调用
        window.wx.onMenuShareAppMessage({
          title: this.detail.activityName, // 分享标题
          desc: this.detail.description, // 分享描述
          link: shareUrl, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
          imgUrl: this.detail.bannerUrl, // 分享图标
          success: () => {
            // 用户点击了分享后执行的回调函数
          },
        })
        window.wx.onMenuShareTimeline({
          title: this.detail.activityName, // 分享标题
          link: shareUrl, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
          imgUrl: this.detail.bannerUrl, // 分享图标
          success: () => {
            // 用户点击了分享后执行的回调函数
          },
        })
        Toast.clear()
      })
    },
    // 获取活动详情数据
    getData() {
      console.log('------------')
      const timestamp = new Date().getTime()
      const sign = md5.hexMD5(`${this.id}${timestamp}!_activity_info_!`)
      return new Promise((s) => {
        this.$http
          .get(
            `aocampaign/openapi/activity/logout/info/${this.id}?sign=${sign}&timestamp=${timestamp}&shareId=${this.shareId}`
          )
          .then((res) => {
            this.detailData(res)
            s()
          })
      })
    },
    makePhone() {
      // uni.makePhoneCall({
      //   phoneNumber: this.poster.views[5].text + '',
      // })
      window.location.href = `tel:${this.detail.serviceTel}`
    },
    // 调取详情数据成功
    detailData(res) {
      Toast.clear()
      this.detail = res.data

      document.title = this.detail.activityName
      this.detail.settingList.forEach((item) => {
        this.settingMap[item.type] = item.enable
      })
      // 专享活动支持图片或视频,故采用JSON串存储
      if(res.data.activityUrl){
        if (this.detail.activityType === 'SPECIAL'){
          const arr = JSON.parse(res.data.activityUrl)
          if (arr && arr.length > 0) {
            this.imgs = arr.map(item => {
              return {
                ...item,
                height: item.width ? Math.ceil((window.screen.width * item.height) / item.width) : window.screen.width * 0.5,
              }
            })
          }
        } else {
          this.imgs = res.data.activityUrl.split(',')
        }
      }
      // this.imgs = res.data.activityUrl.split(',')
      console.log(this.imgs)
    },
    tapCheck() {
      if (this.url) {
        // this.qrModel = true
      }
    },
    openLocation() {
      this.$refs.mapLocationViewer.openViewer({
        value: this.detail.address
      })
    },
    onVideoLoadedMetadata({ detail }, index) {
			console.log(`onVideoLoadedMetadata-${index}`, detail)
			// this.imgs[index].height = Math.ceil((window.screen.width * detail.height) / detail.width)
		},
  },
}
</script>

<style lang="less" scoped>
.vcard {
  // padding: 16px;
  // background: #fff;
}
.qr_code {
  width: 100%;
  background: #fff;
  text-align: center;
  font-size: 16px;
  line-height: 20px;
  color: #323233;
  padding: 10px;
  img {
    width: 80%;
    margin: 18px auto;
  }
}
.top-tip {
  position: fixed;
  top: 75px;
  z-index: 10;
  height: 100px;
}
img {
  vertical-align: bottom;
  display: block;
}
/deep/.van-overlay {
  background: rgba(0, 0, 0, 0.88);
}
/deep/.van-notice-bar {
  height: 28px;
}
.van-popup {
  border-radius: 8px;
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
.mask {
  position: relative;
  .arrow {
    position: absolute;
    right: 80upx;
    top: 10px;
  }
  .txt {
    width: 100%;
    position: absolute;
    top: 130px;
    font-weight: 500;
    text-align: center;
    font-size: 20px;
    line-height: 28px;
    color: #fff;
    div {
      margin-bottom: 20px;
    }
    .btn {
      width: 156px;
      border-radius: 50px;
      border: 1px solid #fff;
      height: 44px;
      line-height: 44px;
      margin: 30px auto;
      font-size: 16px;
    }
  }
}
.btn-bg {
  background: #7d7e80 !important;
}
.detail {
  padding-top: 64px;
  padding-bottom: 124px;
  /deep/.vue-notification-group {
    top: 75px !important;
    left: -42px !important;
  }
  .title {
    width: 100%;
    position: fixed;
    z-index: 99;
    top: 0;
    background: #fff;
    height: 64px;
    box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.1);
    padding: 0 16px;
    .logo {
      width: 32px;
      height: 32px;
    }
    .p3 {
      padding-left: 12px;
      padding-right: 4px;
    }
  }
  .float-btn {
    width: 100%; 
    display: flex; 
    justify-content: center; 
    position: fixed;
    padding-bottom: 8px;
    opacity: 0.6;
    background: linear-gradient(180deg, rgba(5, 19, 48, 0) 0%, #051330 120.83%);
  }
  
  .content {
    background: #fff;
    margin-bottom: 8px;
    padding: 17px 16px 0px 16px;
    .banner {
      width: 100%;
      // height: 200px;
      max-height: 240px;
      border-radius: 3px;
    }
    .content-title {
      font-weight: 600;
      font-size: 20px;
      line-height: 28px;
      margin-top: 20px;
      margin-bottom: 4px;
      color: #323233;
    }
    .content-desc {
      font-weight: 300;
      font-size: 14px;
      line-height: 20px;
      margin-top: 0px;
      margin-bottom: 4px;
      letter-spacing: 1px;
      color: #777777;
    }
    .times {
      padding-bottom: 12px;
      font-size: 11px;
      line-height: 20px;
      color: #7d7e80;
      justify-content: space-between;
    }
  }
  .cell-title {
    padding: 2px 0;
    display: flex;
    align-items: center;
    // font-size: 13px;
  }
  .msg {
    margin-bottom: 8px;
  }
  .desc {
    padding-top: 12px;
    background: #fff;
    .tip {
      margin: 8px 14px;
      padding: 4px 6px;
      background: #f7f8fa;
      border-radius: 3px;
      font-size: 12px;
      line-height: 20px;
    }
  }
  .imgs {
    background: #fff;
    .tip {
      margin: 8px 14px;
      padding: 4px 6px;
      background: #f7f8fa;
      border-radius: 3px;
      font-size: 12px;
      line-height: 20px;
    }
    .video{
      width: 100%;
      height: calc(100vh - 124px);
    }
  }
  .footer {
    width: 100%;
    height: 64px;
    position: fixed;
    bottom: 0;
    padding-top: 12px;
    padding-bottom: 20px;
    background: #fff;
    box-shadow: 0px 2.56201px 30.7442px rgba(0, 0, 0, 0.06);
    justify-content: center;
    z-index: 200;
    .top {
      height: 100%;
      .items {
        width: 60px;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        font-size: 11px;
        line-height: 20px;
      }
    }
    .tab-active {
      background: #fff;
      position: absolute;
      bottom: 51px;
      left: -6px;
      .items {
        height: 50px;
      }
    }
    /deep/.van-hairline--surround::after {
      border-width: 0;
    }
  }
  .notice {
    position: fixed;
    width: 100%;
    bottom: 80px;
    /deep/.van-notice-bar__content {
      color: #fff;
    }
    /deep/.van-notice-bar {
      color: #fff;
      border-radius: 50px;
      margin: 0 20px;
      color: #fff;
      background: linear-gradient(
        90deg,
        rgba(232, 77, 52, 0.8) -3.57%,
        rgba(236, 138, 97, 0.8) 50%
      );
    }
  }
  .notice-x {
    bottom: 110px;
  }

  .custom-template {
    padding: 0 16px;
    margin-bottom: 4px;
    display: flex;
    align-items: center;
    .avatar {
      width: 18px;
      height: 18px;
      border-radius: 50%;
    }
    .tips {
      margin-left: 4px;
      height: 20px;
      line-height: 20px;
      padding: 0 9px;
      border-radius: 50px;
      color: #fff;
      font-size: 10px;
      background: rgba(0, 0, 0, 0.8);
    }
  }
}
.isx {
  padding-bottom: 96px;
}
.coupon {
  margin: 8px 0;
}
.sponsor {
  background: #fff;
  padding: 16px 12px 32px 12px;
  .sponsor-bg {
    background: #f7f8fa;
    border-radius: 3px;
    padding: 12px;
    img {
      width: 16px;
      height: 16px;
    }
    .sponsor-msg {
      font-weight: 500;
      font-size: 14px;
      line-height: 22px;
    }
  }
}

.arrow-down {
  animation: arrow-down 1s infinite;
}

.arrow-up {
  animation: arrow-up 1s infinite;
}

@keyframes arrow-down {
  0% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-3px);
  }
  100% {
    transform: translateY(0);
  }
}

@keyframes arrow-up {
  0% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(3px);
  }
  100% {
    transform: translateY(0);
  }
}
</style>
